import React from 'react';
import Axios from 'axios';
import EditUser from '../../admin/adminUsers/editUser';

class UsersTable extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			activeSection: 'table',
			users: [],
			userEditId: '0'
		};

		this.createUserRow0 = this.createUserRow0.bind(this);
		this.createUserRow1 = this.createUserRow1.bind(this);
		this.editUser = this.editUser.bind(this);
		this.backtoTable = this.backtoTable.bind(this);
	}

	componentDidMount() {
		//console.log('UsersTable: componentDidMount');
		this.loadUsers();
	}

	loadUsers() {
		Axios.get('/api/users/extended').then(response => {
			this.setState({
				users: response.data
			});
		});
	}

	render() {
		//console.log('UsersTable: render');
		//console.log(this.state.users);
		//console.log("this.props.type");
		//console.log(this.props.type);

		// 2 types of UsersTable
		// type 0:  standard table
		// type 1:  with invoice details

		const { activeSection, userEditId } = this.state;

		if (activeSection === 'table') {
			if (this.props.type === "0") {
				return (
					<div className="table-responsive">
						<table className="table table-striped table-hover table-sm">
						<tbody>
							<tr>
								<th></th>
								<th></th>
								<th>ids (user._id, auth0_user_id)</th>
								<th>Noms (auth0, user)</th>
								<th>Admin</th>
								<th>Joueur Associé</th>
								<th>Actif</th>
								<th>Expiration</th>
								<th>Saisons</th>
								<th>Dernière connection</th>
								<th>prevFbId</th>
							</tr>
							{this.state.users.map(this.createUserRow0)}
						</tbody>
						</table>
					</div>
				);

			} else if (this.props.type === "1") {
				return (
					<div className="table-responsive">
					<table className="table table-striped table-hover table-sm">
					<tbody>
						<tr>
							<th>Nom (auth)</th>
							<th>Nom</th>
							<th>Adresse</th>
							<th>Ville</th>
							<th>Province</th>
							<th>Code postal</th>
							<th>Courriel</th>
							<th>Tel</th>
							<th>Active</th>
						</tr>
						{this.state.users.map(this.createUserRow1)}
					</tbody>
					</table>
					</div>
				);
			}
		} else if (activeSection === 'editUser') {
			return ( <EditUser userEditId={userEditId} onSubmitCancel={this.backtoTable} />	)
		}
	}

	createUserRow0(user, userIdx) {
		var seasonsString = '';
		user.seasons.forEach(function(season) {
			seasonsString = seasonsString + season.name;
		});

		var fbAuthIdStatus = (user.fbAuthIdStatus || "");
		return (
			<tr key={user._id}>
				<td><input name={'edit.' + user._id} type="button" onClick={this.editUser} value="Éditer"/></td>
				<td><img className="img-stand-token" src={user.picture}/></td>
				<td>{user._id} <br/>
						{user.auth0_user_id}</td>
				<td>{user.auth0_name} <br/>
						{user.name}</td>
				<td>{user.adminLevel}</td>
				<td>{user.playerName}</td>
				
				{(user.memberActive) ? 
					<td><strong>M</strong></td> :
					<td>-</td>
				}
				<td>{user.memberDateExpiration}</td>

				{this.tdSeasons(user.seasons)}

				<td>{user.lastConnectionDate}</td>
				<td>{fbAuthIdStatus}</td>
		 </tr>
		);
	}

	createUserRow1(user, userIdx) {
		return (
			<tr key={user._id}>
				<td>{user.auth0_name}</td>
				<td>{user.name}</td>
				<td>{user.streetaddress}</td>
				<td>{user.addresslevel2}</td>
				<td>{user.addresslevel1}</td>
				<td>{user.postalcode}</td>
				<td>{user.email}</td>
				<td>{user.tel}</td>
				<td>{user.memberActive.toString()}</td>
		 	</tr>
		);
	}

	tdSeasons(seasons) {
		return (
			<td>
				{seasons.map(function(season, idx) {
				return (
					<p key={'season' + idx} className="insideTableNoMargin">
						{season.name}
					</p>
				);
				})}
			</td>
		);
	}

	editUser(e) {
		var elemInfo = e.target.name.split(".");
		var userEditId = elemInfo[1];
		this.setState({ 
			activeSection: 'editUser',
			userEditId: userEditId
		});
	}

	backtoTable () {
		this.setState({ 
			activeSection: 'table',
			userEditId: '0'
		}, this.loadUsers());
	}

}

export default UsersTable;
